export default "__VITE_ASSET__Cm1be1r3__"